module.exports = __webpack_public_path__ + "img/8.5077140c.jpg";